const context = require.context("./", false, /\.js$/);
const keys = context.keys().filter(item => item !== "./index.js");

const obj = {};
for (let i = 0; i < keys.length; i += 1) {
  Object.assign(obj, context(keys[i]).default);
}

export default obj;
